import "core-js/stable"
import "regenerator-runtime/runtime"
import smoothscroll from 'smoothscroll-polyfill'
import $ from 'jquery'
window["jQuery"] = $
window.$ = $
import GHeader from './component/GHeader'
import Accordion from './component/Accordion'
import './component/Dialog'
import selectric from 'selectric'
import validate from 'validate.js'
window["smoothscroll"] = smoothscroll
window["validate"] = validate
window["selectric"] = selectric
import "../../assets/vrules.js"
import "../../assets/eligibility.js"
import "../../assets/contact.js"
import "../../assets/joinnetwork.js"
import "../../assets/testimonials.js"
import "../../assets/login.js"

var windowW = window.innerWidth

new GHeader()
document.querySelectorAll('.accordion').forEach(a => new Accordion(a))
document.querySelectorAll('.toggle').forEach(i => {
	var s = i.href || i.dataset.target,
			target = document.querySelector(s)
	i.addEventListener('click', (e) => {
		e.preventDefault()
		e.stopPropagation()
		console.log('Clicked');
		if (target.style.display) {
			i.classList.remove('on')
			target.style.display = null
		}
		else {
			i.classList.add('on')
			target.style.display = 'block'
		}
	})
})

/*  Only on mobile */
if (windowW < 768) {
	let slickOptionSmall = {
		arrows: true,
		centerMode: false,
		dots: true,
		infinite: false,
		slidesToshow: 1,
		variableWidth: true,
	}
	$('.slick-in-small').slick(slickOptionSmall)
}
